'use strict';

intellidealerAppPartsModule.filter('availabilityOrder', function ($filter) {
  var order = $filter('language')('mydealer.ui.parts.order');
  return function(availability) {
    return (angular.isDefined(availability) ? ((availability > 0) ? availability : order) : null);
  };
});